import { useEffect, useRef, useState } from 'react';
import type { Coordinates } from '@/lib/restaurantDistance';

export function useDistanceLocation() {
  const [coordinates, setCoordinates] = useState<Coordinates | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const requestId = useRef(0);

  useEffect(() => () => { requestId.current += 1; }, []);

  const cancelLocation = () => {
    requestId.current += 1;
    setLoading(false);
    setError(null);
  };

  const requestLocation = () => {
    const id = ++requestId.current;
    setError(null);
    if (!navigator.geolocation || !window.isSecureContext) {
      setError('A helymeghatározás ebben a böngészőben nem érhető el.');
      return;
    }
    setLoading(true);
    navigator.geolocation.getCurrentPosition(position => {
      if (requestId.current !== id) return;
      setCoordinates({ latitude: position.coords.latitude, longitude: position.coords.longitude });
      setLoading(false);
    }, failure => {
      if (requestId.current !== id) return;
      setLoading(false);
      setError(failure.code === 1
        ? 'A helymeghatározás nincs engedélyezve. Engedélyezd a böngészőben, majd próbáld újra.'
        : failure.code === 3 ? 'A helymeghatározás túl sokáig tartott. Próbáld újra.'
          : 'A jelenlegi helyed nem határozható meg. Próbáld újra.');
    }, { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 });
  };

  return { coordinates, loading, error, requestLocation, cancelLocation };
}